// src/utils/env-detector.js
/* global wx */

// 环境类型枚举
const ENV_TYPES = {
  MINI_PROGRAM: 'miniprogram',
  WECHAT: 'wechat',
  BROWSER: 'browser',
  OTHER: 'other'
}

// 工具函数
export function isInMiniProgram() {
  const ua = navigator.userAgent.toLowerCase()
  
  if (ua.includes('miniprogram')) {
    return true
  }
  
  if (window.__wxjs_environment === 'miniprogram') {
    return true
  }
  
  if (typeof wx !== 'undefined' && wx.miniProgram) {
    return true
  }
  
  return false
}

export function isInWechatBrowser() {
  const ua = navigator.userAgent.toLowerCase()
  return ua.includes('micromessenger') && !isInMiniProgram()
}

export function getCurrentEnv() {
  if (isInMiniProgram()) {
    return ENV_TYPES.MINI_PROGRAM
  }
  
  if (isInWechatBrowser()) {
    return ENV_TYPES.WECHAT
  }
  
  if (/mobile|android|iphone/i.test(navigator.userAgent)) {
    return ENV_TYPES.BROWSER
  }
  
  return ENV_TYPES.OTHER
}

// 环境检测器类
class EnvDetector {
  constructor() {
    this.env = getCurrentEnv()
    this.init()
  }
  
  init() {
    if (this.isMiniProgram) {
      console.log('小程序环境初始化...')
      this.setupMiniProgram()
    }
  }
  
  setupMiniProgram() {
    if (window.wx && window.wx.miniProgram) {
      this.miniProgramAPI = window.wx.miniProgram
    }
  }
  
  get isMiniProgram() {
    return this.env === ENV_TYPES.MINI_PROGRAM
  }
  
  get isWechat() {
    return this.env === ENV_TYPES.WECHAT
  }
  
  get isBrowser() {
    return this.env === ENV_TYPES.BROWSER
  }
  
  getEnvInfo() {
    return {
      env: this.env,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      isMobile: /mobile|android|iphone/i.test(navigator.userAgent)
    }
  }
}

// 创建单例
export const envDetector = new EnvDetector()

// Vue插件
export const EnvPlugin = {
  install(Vue) {
    Vue.prototype.$env = envDetector
    Vue.prototype.$isMiniProgram = () => envDetector.isMiniProgram
    Vue.prototype.$isWechat = () => envDetector.isWechat
    Vue.getEnvInfo = () => envDetector.getEnvInfo()
  }
}

// src/utils/env-detector.js
export function isMiniProgram() {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('miniprogram') || window.__wxjs_environment === 'miniprogram';
}

export function isWechat() {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('micromessenger') && !isMiniProgram();
}